import heroImage from "@/assets/hero-new.webp";

const Hero = () => {
  return (
    <section className="relative h-screen flex items-center overflow-hidden" aria-label="Velkomst">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Kvinne i tradisjonell norsk bunad i norsk landskap"
          className="w-full h-full object-cover"
          fetchPriority="high"
        />
        <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black/40 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full pt-20">
        <div className="max-w-md sm:max-w-lg md:max-w-xl">
          <h1
            className="font-serif text-white drop-shadow-lg"
          >
            <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold" style={{ lineHeight: 1.15 }}>
              Norskproduserte bunader
            </span>
            <span className="block text-lg sm:text-xl md:text-2xl font-light mt-4 text-white/80 tracking-wide font-sans" style={{ lineHeight: 1.5 }}>
              Vi syr bunaden din med respekt for norske tradisjoner
            </span>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default Hero;
